import { useCallback } from 'react';
import { dictionaryApi } from '../api/endpoints';
import { useUi } from '../context/UiContext';

/**
 * Создание записи справочника прямо из формы (поле «Авторы», «Ключевые слова»).
 * Новая запись добавляется в список вариантов и сразу выбирается.
 *
 * @param type        тип справочника: authors | keywords | ed-authors | ed-categories | dis-authors
 * @param setOptions  сеттер списка вариантов страницы
 * @param noun        как назвать запись в уведомлении («автор», «ключевое слово»)
 */
export const useDictionaryCreate = (type, setOptions, noun = 'запись') => {
    const { toast } = useUi();

    return useCallback(
        async (name) => {
            try {
                const created = await dictionaryApi.create(type, { name });
                const option = { value: created.id, label: created.name };
                setOptions((list) => [...list, option]);
                toast.success(`Добавлен${noun.endsWith('о') ? 'о' : ''} ${noun}: «${created.name}»`);
                return option;
            } catch (e) {
                toast.error(e.message);
                return null;
            }
        },
        [type, setOptions, noun, toast]
    );
};

export default useDictionaryCreate;
